import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticlesSection() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold">
            最新攻略与资讯
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            最热的黄游戏攻略、评测与排行内容
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {latestArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/60 transition-all duration-300 cursor-pointer flex flex-col"
          >
            <div className="relative w-full aspect-[16/9] overflow-hidden">
              <img
                src={article.coverImageUrl}
                alt={article.title}
                title={article.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-3 left-3 flex items-center gap-2">
                <span
                  className={`px-2.5 py-1 rounded-md text-xs font-medium text-background-50 ${
                    article.categorySlug === 'guide'
                      ? 'bg-primary-500'
                      : article.categorySlug === 'ranking'
                        ? 'bg-accent-500'
                        : 'bg-secondary-500'
                  }`}
                >
                  {article.category}
                </span>
              </div>
            </div>
            <div className="p-4 flex flex-col gap-2 flex-1">
              <h3 className="font-heading text-base text-foreground-900 font-bold group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between mt-auto pt-2 text-xs text-foreground-400">
                <div className="flex items-center gap-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span>{article.publishDate}</span>
                </div>
                <span className="text-primary-600 font-medium group-hover:translate-x-1 transition-transform inline-flex items-center gap-1 whitespace-nowrap">
                  阅读全文
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}